import ColorBoxes from "../../../../../../packages/design-system/src/Color";
import Spacings from "../../../../../../packages/design-system/src/Spacings";
import theme from "../../../../../../packages/design-system/src/designTokens";
import * as React from 'react';
export default {
  ColorBoxes,
  Spacings,
  theme,
  React
};